import { Button, Input, Space, Table } from "antd";
import { subjectColors } from "utilFunctions/Constants/subjectColorCodes";
import styled from "styled-components";
import TableLayoutAntd from "utilFunctions/shared/AntdSharedComponents/TableLayoutAntd";
import moment from "moment";
import { SearchOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { displayNumberWithDecimals } from "Pages/BranchHealth/BranchHealthTable";
import { roundToAnyDecimalPlaces } from "utilFunctions/helperFunctions/utilFunctions";
import type { InputRef, TableColumnsType, TableColumnType } from "antd";
import type { FilterDropdownProps } from "antd/es/table/interface";
import Highlighter from "react-highlight-words";
import { useRef, useState } from "react";
import {
  returnRiskSegment,
  returnStatus,
} from "Pages/MyBatches/MyBatch/MyBatchTabs/MyBatchStudentDetailsTable";
export const returnColor = (subject: string) => {
  const selectedSub = subjectColors.filter(
    (ele: any) => ele?.subject?.toLowerCase() == subject?.toLowerCase()
  );
  if (selectedSub.length) {
    return selectedSub[0].colorCode;
  } else {
    return "gray";
  }
};
export const DivStyledStatus = styled<any>("div")`
  background-color: ${(props: any) => props.color};
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  display: flex;
  font-size: 12px;
  padding: 4px 11px;
  color: #ffffff;
  font-style: normal;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
  width: fit-content;
`;
// const tableHeading = [
//   { label: "Stream", value: "sid" },
//   { label: "Class", value: "cid" },
//   { label: "Subject", value: "sjId" },
//   { label: "Board", value: "bid" },
//   { label: "Medium", value: "lang" },
// ];
interface DataType {
  studentName?: string;
  psid?: number;
  batchName?: string;
  lop?: string;
  status?: string;
  commentCounts?: string;
  lastCommentBy?: string;
  lastCommentOn?: any;
}
type DataIndex = keyof DataType;
export interface StudentSearchHistoryTableInterface {
  loading?: boolean;
  data?: any[];
  setSortColumn?: any;
  sortColumn?: string;
  setSortOrder?: any;
  sortOrder?: string;
  children?: any;
  userInfo?: any;
  pagination?: any;
  setPagination?: any;
  onPageChange?: any;
  setItemsPerPage?: any;
  tableName?: any;
  screen?: any;
}
const StudentSearchHistoryTable = ({
  loading,
  data,
  tableName,
  children,
  screen,
}: StudentSearchHistoryTableInterface) => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState<any>("");
  const [searchedColumn, setSearchedColumn] = useState<any>("");
  const searchInput = useRef<InputRef>(null);

  const handleSearch = (
    selectedKeys: string[],
    confirm: FilterDropdownProps["confirm"],
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchedColumn("");
    setSearchText("");
  };
  const getColumnSearchProps = (
    dataIndex: DataIndex
  ): TableColumnType<DataType> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          {/* <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button> */}
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    // filterDropdownProps: {
    //   onOpenChange(open: any) {
    //     if (open) {
    //       setTimeout(() => searchInput.current?.select(), 100);
    //     }
    //   },
    // },
    render: (text, record) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          className="tableIdStyle"
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
          onClick={() => onClickStudent(record)}
        />
      ) : (
        <span className="tableIdStyle" onClick={() => onClickStudent(record)}>
          {record[dataIndex]}
        </span>
      ),
  });

  const columns: TableColumnsType<DataType> = [
    {
      title: "Student Name",
      dataIndex: "studentName",
      key: "studentName",
      fixed: ["xxl", "xl", "lg"].includes(screen) ? "left" : undefined,
      ...getColumnSearchProps("studentName"),
      //   render: (_: any, record: any) => {
      //     return (
      //       <span className="tableIdStyle" onClick={() => onClickStudent(record)}>
      //         {record.studentName}
      //       </span>
      //     );
      //   },
    },
    {
      title: "PSID",
      dataIndex: "psid",
      key: "psid",
      ...getColumnSearchProps("psid"),
    },
    {
      title: "Batch",
      dataIndex: "batchName",
      render: (_: any, record: any) => {
        return <span>{record.batchName}</span>;
      },
    },

    {
      title: "LOP Segment | Risk%",
      dataIndex: "lop",
      width: 190,
      render: (_: any, item: any) => {
        return (
          <div className="d-flex flex-row align-items-center">
            <span className="pr-2">{returnRiskSegment(item.riskSegment)}</span>
            {item.risk > 0 && (
              <span>
                |{"  "}
                {roundToAnyDecimalPlaces(
                  Number(displayNumberWithDecimals(item.risk * 100)),
                  2
                )}{" "}
                %{" "}
              </span>
            )}
          </div>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (_: any, item: any) => {
        return <div>{returnStatus(item?.status, item)}</div>;
      },
    },
    {
      title: "Comments",
      dataIndex: "commentCounts",
      render: (_: any, record: any) => {
        return <span>{record.commentCounts}</span>;
      },
    },
    {
      title: "Last Comment by",
      dataIndex: "lastCommentBy",
      render: (_: any, record: any) => {
        return record.lastCommentBy && record.lastCommentBy != null ? (
          <span>{record.lastCommentBy}</span>
        ) : (
          <span>-</span>
        );
      },
    },
    {
      title: "Last Comment Date/Time",
      dataIndex: "lastCommentOn",
      sorter: (a: any, b: any) =>
        new Date(b.lastCommentDate).getTime() -
        new Date(a.lastCommentDate).getTime(),
      render: (_: any, record: any) => {
        return record.lastCommentDate > 0 && record.lastCommentDate != null ? (
          <span>
            {moment(record.lastCommentDate).format("DD-MM-YYYY hh:mm a")}
          </span>
        ) : (
          <span>-</span>
        );
      },
    },
  ];
  const onClickStudent = (record: any) => {
    navigate("/admin/performance/" + record.psid, {
      replace: false,
      state: {
        selectedStudent: record,
      },
    });
  };
  return (
    <TableLayoutAntd
      isLoader={loading}
      style={{ height: "70vh", overflow: "auto" }}
    >
      {["xxl", "xl", "lg"].includes(screen) ? null : (
        <div className="mb-3">{children}</div>
      )}

      <Table
        scroll={{ x: "max-content" }}
        bordered
        size="small"
        columns={
          tableName == "History"
            ? columns
            : columns.filter((el: any) => el.dataIndex != "batchName")
        }
        dataSource={data}
        pagination={false}
      />
    </TableLayoutAntd>
  );
};
export default StudentSearchHistoryTable;
